import { render, staticRenderFns } from "./AccountsPayableFilesComponent.vue?vue&type=template&id=0b3d75ae"
import script from "./AccountsPayableFilesComponent.vue?vue&type=script&lang=js"
export * from "./AccountsPayableFilesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports